import React from "react";
import { Box, Card, CardContent, Skeleton, Stack } from "@mui/material";

export default function AppLoadingSkeleton({
  rows = 3,
  showHeader = true,
  cardHeight = 72,
  dense = false,
}) {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        p: { xs: 1.5, sm: 2 },
      }}
    >
      {showHeader && (
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: "none",
            border: "1px solid rgba(148, 163, 184, 0.18)",
          }}
        >
          <CardContent
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="42%" height={24} />
              <Skeleton variant="text" width="68%" height={16} />
            </Box>
            <Skeleton variant="circular" width={40} height={40} />
          </CardContent>
        </Card>
      )}

      <Stack spacing={1.5}>
        {Array.from({ length: rows }).map((_, index) => (
          <Card
            key={`skeleton-${index}`}
            sx={{
              borderRadius: 3,
              boxShadow: "none",
              border: "1px solid rgba(148, 163, 184, 0.18)",
            }}
          >
            <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Skeleton variant="text" width={dense ? "48%" : "62%"} height={20} />
                <Skeleton variant="rectangular" width={dense ? 72 : 92} height={28} sx={{ borderRadius: 999 }} />
              </Box>
              <Skeleton variant="text" width="84%" />
              <Skeleton variant="text" width={dense ? "56%" : "72%"} />
              <Skeleton
                variant="rectangular"
                height={cardHeight}
                sx={{ borderRadius: 2, mt: 0.5 }}
              />
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Box>
  );
}
